import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../../colors-v2';
import { Typography } from '../../../../../DesignSystemV2/Typography';
import { shadows } from '../../../../../shadows';
import { useExerciseQuizDoTestStore } from '../../store/exercise-quiz-do-test.store';
import { DoTestExerciseQuizProps } from '../../types';
import { DoTestActions } from './DoTestActions';

const Main = styled.div`
  padding: 24px;
  background: ${colorsV2.white100};
  border: 1px solid ${colorsV2.gray40};
  box-shadow: ${shadows.zIndex3};
  border-radius: 8px;
  .question-navigator-text {
    text-align: center;
  }
`;

export const DoTestExerciseQuizQuestions = observer((props: DoTestExerciseQuizProps) => {
  const { children, attributes, element } = props;
  const store = useExerciseQuizDoTestStore();
  return (
    <Spin spinning={store.submitting}>
      <Main className="do-test-exercise-quiz-questions" contentEditable={false} {...attributes}>
        <div
          contentEditable={false}
          className="question-navigator-text"
          onMouseDown={(e) => e.preventDefault()}
        >
          <Typography.Text mb={12} variant="semi-bold/14" color="gray100">
            QUIZ {store.currentQuizIndex + 1}/{element?.children?.length || 0}
          </Typography.Text>
        </div>
        {children}
        <DoTestActions {...props} />
      </Main>
    </Spin>
  );
});
